<template>
  <div class="content-wrapper menu-item">
    <div class="hidden relative sm:block menu-item-icon">
      <div class="icons mr-6">
        <div
          v-for="(flag, index) in getUsageDetails"
          :key="`usage-flag-${index}`"
          class="mb-2"
        >
          <Tag
            size="small"
            :class="[ flag.label === 'カフェ' || flag.label === '補助クーポン' ? 'plan-icon cafe-icon' : 'plan-icon' ]"
          >
            {{ flag.label }}
          </Tag>
        </div>
      </div>

      <a class="icon text-xl absolute right-0 top-0 menu-item-icon-favorite" @click.stop="onFavourite(menu)">
        <Icon name="heart" class="h-5 w-5" :fill="!isFavourite(menu) ? 'none' : '#e60021'"/>
      </a>
    </div>

    <div class="flex">
      <div
        class="menu-item-title-thumbnail mr-4"
        :style="{
          'background-image': `url(${get(
            menu,
            'menuImgList[0].imageUrl',
            require('@/assets/images/slide-img-placeholder.png')
          )})`
        }"></div>

      <div class="menu-item__titleBox flex-row flex-grow hover-pointer" @click="goToMenuDetail(menu.menuNo)">
        <div class="relative sm:hidden">
          <div class="icons mr-6">
            <div
              v-for="(flag, index) in getUsageDetails"
              :key="`usage-flag-${index}`"
            >
              <Tag
                size="small"
                :class="[ flag.label === 'カフェ' || flag.label === '補助クーポン' ? 'plan-icon cafe-icon' : 'plan-icon']"
              >
                {{ flag.label }}
              </Tag>
            </div>
          </div>

          <a class="icon text-xl absolute right-0 top-0" @click.stop="onFavourite(menu)">
            <Icon name="heart" class="h-5 w-5" :fill="!isFavourite(menu) ? 'none' : '#e60021'"/>
          </a>
        </div>

        <a class="menu-no sm:mt-0"
              @click="goToMenuDetail(menu.menuNo)"
              v-if="menu && menu.menuNo">
              [メニューNo.{{ menu.menuNo }}]
        </a>

        <h2 v-if="menu && menu.menuNm" class="menu-title mt-2">
          <a
            v-html="menu.menuNm.replaceAll('\n', '<br>')"
            class="text-black text-epip title-menu"
            @click="goToMenuDetail(menu.menuNo)"
          />
        </h2>

        <div class="address mt-5 sm:hidden">
          <span v-if="menu.prefNm" class="icon icon-bor-pin mr-1.5" />
          <span class="mr-3">
            <!-- 確認：大エリア小エリア両方登録されている場合は？ -->
            <!--
              現在の状態
              大エリア（areaMidClassNm）：京都府
              小エリア（areaDtlClassNm）：大原・鞍馬・貴船
              両方設定されていた場合は「京都府 > 大原・鞍馬・貴船」となっている
             -->
            {{ menu.prefNm }}
          </span>

          <button
            v-if="menu.lat !== 0 && menu.lng !== 0"
            class="c-btn btn-sm btn-white"
            @click.stop="gotoMap(menu.lat, menu.lng)"
          >
            地図を見る
          </button>
        </div>

        <div class="hidden menu-item-title-rating hover-pointer mb-1.5 sm:flex" @click="goToMenuDetail(menu.menuNo)">
        </div>
      </div>
    </div>

    <div class="hover-pointer mt-5 sm:mt-3" @click="goToMenuDetail(menu.menuNo)">
      <div
        class="title text-epip mb-3"
        v-if="menu && menu.tokusyoku"
        v-html="menu.tokusyoku.replaceAll('\n', '<br>')"
      ></div>
    </div>

    <div class="hidden address sm:flex">
      <span v-if="menu.prefNm" class="mr-1 menu-item__mapIcon">
        <img
          src="@/assets/icon/icon_map_red.svg"
          alt=""
        >
      </span>
      <span class="mr-3 menu-item__address">
        <!-- 確認：大エリア小エリア両方登録されている場合は？ -->
        <!--
          現在の状態
          大エリア（areaMidClassNm）：京都府
          小エリア（areaDtlClassNm）：大原・鞍馬・貴船
          両方設定されていた場合は「京都府 > 大原・鞍馬・貴船」となっている
          -->
        {{ menu.prefNm }}
      </span>

      <button
        v-if="menu.lat !== 0 && menu.lng !== 0"
        class="c-btn btn-sm btn-white menu-item__mapBtn"
        @click.stop="gotoMap(menu.lat, menu.lng)"
      >
        地図を見る
      </button>
    </div>

    <!--Category Stay-->
    <template v-if="filterForm.category === 'stay'">
      <section class="p-0 mt-4 sm:mt-2">
        <div
          class="suggest-item"
          v-for="(plan, index) in menu.plans"
          :key="`menu-plan2-${index}`"
        >
          <!--Desktop-->
          <div class="suggest-item-wrapper" :class="index > 0 ? 'sm:hidden' : '' ">
            <div class="flex" v-if="plan.planIcons.length > 0 || zaikoList.length > 0">
              <!-- ベネポのロゴ -->
              <ul class="menu-item__tagList">
                <li v-for="(item, index) in plan.planIcons" :key="`tagsText-${index}`">
                  <Tag
                    :text="item.iconNm"
                    :class="[ 
                      item.iconNm === 'カフェ' || item.iconNm === '補助クーポン'
                      ? 'plan-icon cafe-icon'
                      : 'plan-icon',
                      item.iconNm === 'ベネポ貯まる' || item.iconNm === 'ベネポ使える'
                      ? 'plan-icon bene-icon'
                      : 'plan-icon',
                      item.iconNm === 'オンラインカード決済可' || item.iconNm === 'オンラインカード決済'
                      ? 'plan-icon online-payment-icon'
                      : 'plan-icon',
                    ]"
                    class="mb-2.5 sm:mb-2"
                  />
                </li>
              </ul>
              <template v-for="(item, index) in zaikoList">
                <!-- 残数 or 空室情報 -->
                <div
                 :key="`vacancy-${index}`"
                 v-if="item.menuNo === menu.menuNo && item.planId === plan.planId && item.roomId === plan.roomId"
                 class="menu-item__stockIcon">
                  <Tag
                    :text="item.stock"
                    class="plan-icon plan-icon__vacancy mb-2.5 sm:mb-2"
                  />
                </div>
              </template>
            </div>

            <div class="flex justify-between items-center mb-2">
              <div class="content-title">
                <a class="text-black text-epip plan-title">
                  <!-- プラン名 -->
                  {{ plan.title }}
                </a>
              </div>
            </div>
            
            <div class="flex items-center justify-between mb-2">
              <div class="flex items-center">
                <!-- ベネオリ・ベネ楽のロゴ -->
                <img
                  src="@/assets/images/recomment-rakuten.png"
                  alt=""
                  v-if="get(menu, 'extImpSysCd') === 'RakutenT'"
                />
                <img src="@/assets/images/bene-log.png" alt="" v-else />
                <div class="flex items-center text-xs ml-3 font-bold">
                  <Icon name="food" />
                  <!-- 朝食・夕食ありなしテキスト -->
                  {{ roomEatServiceText(plan) }}
                </div>
              </div>
            </div>

            <div class="plan-type flex items-center mb-4" v-if="plan.na">
              <p class="plan-type__text">{{ plan.na }}</p>
            </div>

            <div class="menu-item__priceWrap">
              <div class="menu-item__priceWrap--inside">
                <!-- <div class="flex items-center flex-grow sm:mb-2"> -->
                <Tag class="suggest-item-tag">
                  {{ plan.dateAvailables[0].kinKubun === '1' ? '1泊の料金' : '大人' + getConditions().adultHeadCnt + '人' + (getConditions().childCnt > 0 ? '/子ども' + getConditions().childCnt + '人/' : '/') + getConditions().stayNights + '泊' }}
                </Tag>
              </div>
            </div>

            <div class="menu-item__priceTotalWrap">
              <!-- プランの最安値 -->
              <p class="suggest-item-price">合計<span class="suggest-item-price--amount">{{ plan.minPrice | separatedByCommas }}</span>円{{ $route.query.checkInDate ? '' : '～' }}</p>
              <Tag v-if="!getConditions().childCnt" class="suggest-item-perPerson">
                {{ plan.dateAvailables[0].kinKubun === '1' ? '1泊の料金' : '大人1名あたり' }}{{ Math.round(plan.minPrice / (getConditions().adultHeadCnt * getConditions().roomCnt)) | separatedByCommas }}{{ '円' }}{{ $route.query.checkInDate ? '' : '～' }}
              </Tag>
            </div>

            <div class="menu-item__bottomWrap">
              <div class="menu-item__granted" v-if="plan.planIcons.filter(data => data.iconCd === 'benepo_tamaru').length == 1">
                <p class="menu-item__point">
                  {{ '獲得ベネポ：' }}
                  <span class="menu-item__point--point">
                    <strong class="menu-item__point--number">{{ plan.benepoGrant | separatedByCommas }}</strong>p{{ $route.query.checkInDate ? '' : '～' }}
                  </span>
                  <span class="menu-item__point--rakuten" v-if="get(menu, 'extImpSysCd') === 'RakutenT'">
                    ＋楽天ポイント
                    <span class="menu-item__point--point">
                      <strong class="menu-item__point--number">1</strong>%〜
                    </span>
                  </span>
                </p>
              </div>
              <button class="menu-item__planDetail" @click="gotoPlanDetail(menu, plan)">
                詳細を見る
                <Icon name="arrow_next_small" class="menu-item__planDetail--icon hidden sm:ml-1 sm:inline-block" stroke="#1f2021" width="5.811" height="10.121" />
                <Icon name="arrow_next" class="menu-item__planDetail--icon ml-5 inline-block sm:hidden" stroke="#1f2021" width="7.31" height="13.121"/>
              </button>
            </div>
          </div>

          <!--Mobile-->
          <div class="hidden flex-col hover-pointer"  @click="gotoPlanDetail(menu, plan)">
            <div class="flex flex-col">
              <div class="content-title my-2">
                <a class="text-black text-epip">
                  <!-- プラン名plan.title -->
                  {{ plan.title }}
                </a>
              </div>
              <div class="flex items-center gap-x-4">
                <!-- ベネオリ・ベネ楽のロゴ -->
                <img
                  src="@/assets/images/recomment-rakuten.png"
                  alt=""
                  v-if="get(menu, 'extImpSysCd') === 'RakutenT'"
                />
                <img src="@/assets/images/bene-log.png" alt="" v-else />
                <div class="flex items-center gap-x-4">
                  <i class="icon icon-bor-food"></i>
                  <!-- 朝食・夕食ありなしテキスト -->
                  {{ roomEatServiceText(plan) }}
                </div>
              </div>
            </div>
            <div class="flex justify-end items-center my-3">
              <Tag class="suggest-item-tag mr-2">
                <!-- 人単位か部屋単位のテキスト -->
                {{ plan.dateAvailables[0].kinKubun === '1' ? '1泊の料金' : '大人1人' }}
              </Tag>
              <!-- プランの最安値 -->
              <div class="suggest-item-price">{{ plan.minPrice | separatedByCommas }}円～</div>
            </div>

          </div>
        </div>
      </section>

      <section class="sm:p-0 mt-8 sm:mt-4">
        <div class="footer">
          <button class="c-btn btn-black px-6 plan-detail-button" color="#222222" @click="goToPlanList(menu.menuNo)">
            プラン一覧を見る
            <Icon name="arrow_next_small" class="ml-5 sm:ml-4" stroke="#fff" width="5.811" height="10.121"/>
          </button>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { get, isNil, isEmpty, minBy } from 'lodash'
import moment from 'moment'
import menu_utils from '@/mixins/menu_utils'
import func_utils from '@/mixins/func_utils'
import { DELETE_FAVORITE, SAVE_FAVORITE } from '@/store/modules/bs_myp/actions'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import { createSetCookie } from '@/utils/cookie'

export default {
  name: 'SearchMenuItem',
  props: ['menu', 'isPublicStay', 'filterForm','userSubsidyList','userCafeSubscriptionId','zaikoList','stompClient'],
  mixins: [menu_utils, func_utils],
  data() {
    return {
      // 読み込まないため不要
      // planLoading: false
    }
  },
  filters: {
    separatedByCommas(value) {
      return Number(value).toLocaleString()
    }
  },
  async created() {},
  async mounted() {
    // 不使用
    // this.getPlans()
  },
  methods: {
    get,
    // indexから値が返ってくるため不要
    // async getPlans() {
    //   if (Array.isArray(this.menu.plans)) {
    //     const query = {
    //       adultHeadCnt: this.filterForm.numPeople
    //     }
    //     const { checkInDate, stayNights } = this.filterForm
    //     if (checkInDate) {
    //       query.checkInDay = moment(checkInDate).format('YYYY/MM/DD')
    //       query.checkOutDay = moment(checkInDate)
    //         .clone()
    //         .add(stayNights || 1, 'days')
    //         .format('YYYY/MM/DD')
    //     } else {
    //       query.designatedMo = '0';
    //     }

    //     let processes = []
    //     let response = []

    //     this.menu.plans.forEach((plan) => {
    //       const process = this.$repositories('search').searchPlan(
    //         this.menu.menuNo,
    //         plan.planId,
    //         plan.roomId,
    //         query
    //       )
    //       processes.push(process)
    //     })

    //     this.planLoading = true
    //     response = (await Promise.allSettled(processes))
    //       .filter((item) => item.value)
    //       .map((el) => {
    //         return el.value
    //       })
    //     this.menu.planData = response
    //     this.planLoading = false
    //   }
    // },
    isFavourite(item) {
      return get(item, 'favourite.favourite', false)
    },
    onFavourite(item) {
      if (!this.$auth.loggedIn) {
        this.$modal.open("LoginGuidanceModal");
        return
      }
      const isFavourite = this.isFavourite(item)
      if (isFavourite) {
        this.$store.dispatch(DELETE_FAVORITE, item.favourite.id)
        .then(
          () => {
            this.getFavoriteStatus(item.menuNo).then(
              (result) => {
                item.favourite.id = get(result, 'id', '')
                item.favourite.favourite = get(result, 'favourite', false)
                item.favourite.quantity = get(result, 'quantity', 0)
                this.$emit('onToggleFav',item)
              },
              () => {}
            )
          },
          (err) => {
            const error = err.error
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
      } else {
        this.$store.dispatch(SAVE_FAVORITE, {itemType: 'favourite', menuNo: item.menuNo})
        .then(
          () => {
            this.getFavoriteStatus(item.menuNo).then(
              (result) => {
                item.favourite.id = get(result, 'id', '')
                item.favourite.favourite = get(result, 'favourite', false)
                item.favourite.quantity = get(result, 'quantity', 0)
                this.$emit('onToggleFav',item)
              },
              () => {}
            )
          },
          (err) => {
            const error = err.error
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
      }
    },
    // カテゴリータグを表示
    categoryName(item) {
      let categoryNm = ''
      if (get(item, 'catLrgClassNm')) {
        categoryNm += get(item, 'catLrgClassNm')
      }
      if (get(item, 'catMidClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += get(item, 'catMidClassNm')
      }
      if (get(item, 'catSmlClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += get(item, 'catSmlClassNm')
      }
      return categoryNm
    },

    // indexからprefNmが返ってくるため不要（表示形式についてTODO(templateでも記載)）
    // getAreaName(item) {
    //   const areaMidClassNm = get(item, 'areaInfomation.areaMidClassNm', '')
    //   const areaDtlClassNm = get(item, 'areaInfomation.areaDtlClassNm', '')

    //   if (areaMidClassNm && areaDtlClassNm) {
    //     return `${areaMidClassNm} > ${areaDtlClassNm}`
    //   }
    //   if (areaMidClassNm && !areaDtlClassNm) {
    //     return `${areaMidClassNm}`
    //   }
    //   if (!areaMidClassNm && areaDtlClassNm) {
    //     return `${areaDtlClassNm}`
    //   }
    //   return ''
    // },

    // indexから最安値が返ってくるのでtemplateに処理を書くため不要
    // getLatLong(item) {
    //   const lat = get(item, 'areaInfomation.latitude', '')
    //   const long = get(item, 'areaInfomation.longitude', '')
    //   return !!(lat && long)
    // },

    // indexから最安値が返ってくるのでtemplateに処理を書くため不要
    // calculateRoomPrice(plans) {
    //   let calendar
    //   const data = (plans || []).reduce((acc, plan) => {
    //     if (!this.filterForm.checkInDate) {
    //       // 日付未指定の場合
    //       calendar = get(plan, 'vacancyCalendar.vacancyCalendars', [])
    //       } else {
    //       calendar = get(plan, 'vacancyCalendar.vacancyCalendars', []).find(
    //         (item) => item.stayDay === this.currentDay
    //       )
    //     }
    //     if (calendar) {
    //       return [...acc, calendar]
    //     }
    //     return acc
    //   }, [])

    //   const firstDataParent = data[0] || {}
    //   let firstData;
    //   if (Array.isArray(firstDataParent)) {
    //     firstData = firstDataParent[0] || {}
    //   } else {
    //     firstData = firstDataParent || {}
    //   }
    //   const hasRoomPrice = !isNil(firstData?.roomPrice)
    //   let minPrice = hasRoomPrice ? firstData?.roomPrice : firstData?.price || 0
    //   if (data.length) {
    //     data.forEach((items) => {
    //       if (Array.isArray(items)) {
    //         items.forEach((item) => {
    //           const price = hasRoomPrice ? +item.roomPrice : +item.price
    //           if (minPrice >= price) minPrice = price
    //         })
    //       } else {
    //         const price = hasRoomPrice ? +items.roomPrice : +items.price
    //         if (minPrice >= price) minPrice = price
    //       }
    //     })
    //   }
    //   minPrice = this.formatCurrency(minPrice || this.pricePlan)

    //   minPrice = minPrice ? minPrice : '';

    //   return hasRoomPrice ? `${minPrice}／室` : `${minPrice}/人`
    // },

    // indexから最安値が返ってくるのでtemplateに処理を書くため不要
    // getSymbolPlan(plan) {
    //   if (!this.filterForm.checkInDate) {
    //     // 日付未指定の場合
    //     const calendar = get(plan, 'vacancyCalendar.vacancyCalendars', [])
    //     return !isNil(calendar?.roomPrice) ? '1泊の料金' : '大人1人'
    //   } else {
    //     const calendar =
    //       get(plan, 'vacancyCalendar.vacancyCalendars', []).find(
    //         (calendar) => calendar.stayDay === this.currentDay
    //       ) || {}
    //     return !isNil(calendar?.roomPrice) ? '1泊の料金' : '大人1人'
    //   }
    // },

    roomEatServiceText(plan) {
      const breakfastFlag = plan.dateAvailables[0].bflg
      const dinnerFlag = plan.dateAvailables[0].dflg
      if (breakfastFlag == '1' && dinnerFlag == '1') {
        return '朝食・夕食つき'
      } else if (breakfastFlag == '1') {
        return '朝食のみ'
      } else if (dinnerFlag == '1') {
        return 'ディナーのみ'
      }
      return '食事なし'
    },

    // indexから最安値が返ってくるため不要
    // getPricePlan(plan) {
    //     // const calendar = get(plan, 'vacancyCalendar.vacancyCalendars', [])
    //     let calendar;
    //     if (!this.filterForm.checkInDate) {
    //       // 日付未指定の場合
    //       calendar = get(plan, 'vacancyCalendar.vacancyCalendars', [])
    //     } else {
    //       try {
    //         calendar = get(plan, 'vacancyCalendar.vacancyCalendars', []).find(
    //           (item) => item.stayDay === this.filterForm.checkInDate.format('YYYY/MM/DD')
    //         )
    //       } catch (e) {
    //         if (e instanceof TypeError) {
    //           calendar = get(plan, 'vacancyCalendar.vacancyCalendars', []).find(
    //             (item) => item.stayDay == this.currentDay
    //           )
    //         }
    //       }
    //       if (calendar == null || (Array.isArray(calendar) && calendar.length == 0)) {
    //           calendar = get(plan, 'vacancyCalendar.vacancyCalendars', []);
    //         }
    //     }
    //     if (Array.isArray(calendar)) {
    //       const min = minBy(calendar, 'price');
    //       return this.formatCurrency(min?.price || '');
    //     } else {
    //       return this.formatCurrency(calendar?.price || '');
    //     }
    // },

    // メニュー詳細へ遷移
    goToMenuDetail(menuNo) {
      if (this.isPublicStay) {
        this.$router.push({
          path: `/public-stay/menus/${menuNo}`
        })
        return
      }
      const query = this.$route.query
      // 遷移前の検索画面の情報を保存
      sessionStorage.setItem('previousUrl', JSON.stringify(query))
      query.feeLower = query.feeLower > 0 ? query.feeLower : 0
      query.feeUpper = query.feeUpper > 0 ? query.feeUpper : 0
      // top宿泊画面用の検索条件保持クッキー追加（検索条件が変わっていた場合のみ）
      document.cookie = createSetCookie('cr_stay_search_conditions', encodeURIComponent(JSON.stringify(query)), undefined, true)
      this.$router.push({
        path: `/menus/${menuNo}`,
        query
      })
    },
    // プラン一覧へ遷移
    goToPlanList(menuNo) {
      const query = this.$route.query
      // 遷移前の検索画面の情報を保存
      sessionStorage.setItem('previousUrl', JSON.stringify(query))
      query.feeLower = query.feeLower > 0 ? query.feeLower : 0
      query.feeUpper = query.feeUpper > 0 ? query.feeUpper : 0
      // top宿泊画面用の検索条件保持クッキー追加（検索条件が変わっていた場合のみ）
      document.cookie = createSetCookie('cr_stay_search_conditions', encodeURIComponent(JSON.stringify(query)), undefined, true)
      this.$router.push({
        path: `/menus/${menuNo}/plans`,
        query
      })
    },

    // プラン詳細へ遷移
    gotoPlanDetail(menu, plan) {
      const menuNo = get(menu, 'menuNo', '')
      const planId = get(plan, 'planId', '')
      const roomId = get(plan, 'roomId', '')
      const query = this.$route.query
      // 遷移前の検索画面の情報を保存
      sessionStorage.setItem('previousUrl', JSON.stringify(query))
      this.$router.push({
        path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`,
        query
      })
    },
    // googleMapに遷移
    gotoMap(latitude, longitude) {
      if (latitude !== null && longitude !== null) {
        window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
        return
      }
      window.open('https://maps.google.com')
    },

    getConditions() {
      const childData = [
        'exUpperGradesHeadCnt',
        'exLowerGradesHeadCnt',
        'youjiAHeadCnt',
        'youjiBHeadCnt',
        'youjiCHeadCnt',
        'youjiDHeadCnt'
      ]

      let childCnt = 0;
      childData.forEach((key) => {
        if (this.filterForm[key] > 0) {
          childCnt += parseInt(this.filterForm[key]);
        }
      })
      return {
        checkInDate: this.filterForm.checkInDate,
        stayNights: this.filterForm.checkInDate ? this.filterForm.stayNights : 1,
        adultHeadCnt: this.filterForm.adultHeadCnt,
        childCnt: childCnt,
        roomCnt: Number(this.filterForm.roomCnt) || Number(this.$route.query.roomCnt) || 1,
      };
    },

  },
  computed: {
    query() {
      return this.$route.query
    },

    getUsageDetails() {

      const planIcons = []

      // 補助クーポンアイコンの表示制御
      const menuSubsidyList = this.menu?.subsidyId?.split(",")
      if (this.userSubsidyList !== null) {
        for (let i = 0; i < this.userSubsidyList.length; ++i) {
          const userSubsidy = this.userSubsidyList[i];
          if(menuSubsidyList.find(el => el === userSubsidy )){
            var iconNm = "補助クーポン"
            if ( planIcons.findIndex(icon => icon.iconNm === iconNm) == -1){
              planIcons.push({ iconCD : "subsidy", iconNm, iconSuppl : null });
            }
            break;
          }
        }
      }

      // カフェアイコンの表示制御
      const menuCafeSubscriptionList = this.menu?.cafeSubscriptionId?.split(",")
      if(menuCafeSubscriptionList && menuCafeSubscriptionList.find(el => el === this.userCafeSubscriptionId)){
        var iconNm = "カフェ"
        if ( planIcons.findIndex(icon => icon.iconNm === iconNm) == -1){
          planIcons.push({ iconCD: "cafe", iconNm, iconSuppl: null })
        }
      }

      const activeFlags = planIcons.map((key) => {
        return {
          label: _.get(key, 'iconNm', null),
          value: _.get(key, 'iconNm', null)
        }
      })
      return activeFlags
    },
    totalPeopleCnt() {
      // URLクエリより大人と子どもの人数を取得
      const query = this.$route.query
      const adultHeadCnt = Number(query.adultHeadCnt) || 0
      const exUpperGradesHeadCnt = Number(query.exUpperGradesHeadCnt) || 0
      const exLowerGradesHeadCnt = Number(query.exLowerGradesHeadCnt) || 0
      const youjiAHeadCnt = Number(query.youjiAHeadCnt) || 0
      const youjiBHeadCnt = Number(query.youjiBHeadCnt) || 0
      const youjiCHeadCnt = Number(query.youjiCHeadCnt) || 0
      const youjiDHeadCnt = Number(query.youjiDHeadCnt) || 0

      // 大人＋子どもの総人数を算出
      const totalPeopleCnt = [
        adultHeadCnt,
        exUpperGradesHeadCnt,
        exLowerGradesHeadCnt,
        youjiAHeadCnt,
        youjiBHeadCnt,
        youjiCHeadCnt,
        youjiDHeadCnt,
      ].reduce((a, b) => a + b)

      return totalPeopleCnt
    },

    // 使用しないため不要
    // currentDay() {
    //   const { checkInDate } = this.query
    //   if (!!checkInDate && moment(checkInDate).isValid()) {
    //     return moment(checkInDate).format('YYYY/MM/DD')
    //   }
    //   return moment().format('YYYY/MM/DD')
    // }

    // indexから最安値が返ってくるため不要
    // pricePlan() {
    //   const listVacancy = get(this.menu, 'planData[0].vacancyCalendar.vacancyCalendars')
    //   if (isEmpty(listVacancy)) return ''
    //   else {
    //     const currentCalendar = listVacancy?.find(
    //       (calendar) => calendar.stayDay === this.currentDay
    //     )
    //     if (!isEmpty(currentCalendar)) {
    //       let curentPrice = currentCalendar?.roomPrice ?? currentCalendar?.price
    //       return curentPrice || ''
    //     } else {
    //       const min = minBy(listVacancy, 'price')
    //       return min?.price || ''
    //     }
    //   }
    // }
  },
  watch: {
    // 不使用
    // menu() {
    //   this.getPlans()
    // }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
::v-deep .menu-item-detail-thumbnail {
  .b-carousel-image {
    min-height: unset;
  }
  .thumbnails > div {
    height: 40px;
  }
}

.hover-pointer {
  cursor : pointer;
}

.icons {
  flex-grow: 1;
  display: flex;
  .plan-icon {
    &:hover {
      opacity: 1;
    }
  }
}

.plan-icon {
  @apply mr-2;
  padding: 2px 8px !important;
  letter-spacing: 0px;
  font-size: 10px;
  // 残りx部屋、空室なしのスタイル
  &__vacancy{
    background: #E60021 !important;
    color: #fff !important;
    padding: 2px 8px !important;
  }
}
.cafe-icon {
  color: #f4f5f6 !important;
  background-color: #0d76bf !important;
}
.bene-icon {
  color: #1F2021 !important;
  background-color: #FFD966 !important;
}
.online-payment-icon {
  color: #ffffff !important;
  background-color: #f58700 !important;
}

.menu-title {
  @apply text-xl;
  line-height: 30px;
  font-weight: 700;
  @screen sm {
    @apply text-base;
  }
  &-thumbnail {
    width: 240px;
  }
}

.suggest-item {
  &-tag {
    color: #000 !important;
    background-color: transparent !important;
    padding: 0 !important;
  }
  &-perPerson {
    color: #63666A !important;
    background-color: transparent !important;
    padding: 0 !important;
    display: block;
    font-size: 12px;
    line-height: 1.5;
    margin: 0 0 0 1rem;
  }
  .content-title {
    .plan-title {
      font-feature-settings: "palt";
    }
  }
  &-price {
    font-size: .875rem;
    font-weight: bold;
    line-height: 1.25rem;
    color: #E60021;
    margin-bottom: .5rem;
    &--amount {
      font-size: 1.5rem;
    }
  }
  
}

.plan-type {
  &__text {
    font-weight: bold;
  }
}

.menu-item-title {
  &-thumbnail {
    background-size: cover;
    background-position: center;
    width: 15rem;
    height: 11.25rem;
  }
  &-box {
    flex: 1;
  }
}

.menu-item {
  &__tagList {
    display: flex;
    flex-wrap: wrap;
    .plan-icon {
      &:hover {
        opacity: 1;
      }
    }
  }
  &__stockIcon {
    margin-left: auto;
    .plan-icon {
      &__vacancy {
        font-size: 10px;
        margin-right: 0;
        &:hover {
          opacity: 1;
        }
      }
    }
  }
  &__priceWrap {
    border-top: 1px solid #CACCCF;
    padding-top: 1rem;
    &--inside {
      display: flex;
      align-items: center;
      margin-bottom: .5rem;
    }
  }
  &__priceTotalWrap {
    display: flex;
    align-items: center;
  }
  &__bottomWrap {
    display: flex;
  }
  &__granted {
    font-size: .75rem;
  }
  &__point {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: .75rem;
    &--point {
      font-weight: bold;
      color: #E60021;
      margin-right: 4px;
    }
    &--number {
      font-size: 1rem;
    }
    &--percent {
      font-size: .625rem;
      background: #fff;
      border-radius: 4px;
      padding: 2px 5px;
    }
    &--rakuten {
      display: flex;
      align-items: center;
      margin-left: .5rem;
    }
  }
  &__titleBox {
    position: relative;
    flex: 1;
    padding-right: 1.125rem;
    .tag-padding {
      padding: 3px 5px;
    }
  }
  &__planDetail {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #1F2021;
    border-radius: 4px;
    background: #fff;
    font-size: 0.75rem;
    line-height: 2rem;
    font-weight: bold;
    color: #1F2021;
    text-align: center;
    margin: auto 0 0 auto;
    width: 7.5rem;
    transition: .5s;
    &--icon {
      width: 6px;
    }
    &:hover{
      opacity: .8;
    }
  }
}

@media (max-width: $contentWidthS) {
  .suggest-item {
    &-tag {
      display: block;
      font-size: 0.75rem;
      line-height: 1.5;
      margin-bottom: .5rem;
    }
    &-perPerson {
      display: block;
      font-size: 12px;
      line-height: 1.5;
      margin: 0 0 .5rem;
    }
    &-price {
      margin-bottom: .5rem;
    }
    &-wrapper {
      border: 1px solid #FDEED4;
      border-radius: .5rem;
    }
  }
  .plan-type {
    &__text {
      font-size: .875rem;
      line-height: 1.25rem;
    }
  }
  .menu-item {
    &-icon {
      &-favorite {
        z-index: 1;
      }
    }
    &-title {
      &-thumbnail {
        width: 7.5rem;
        height: 5rem;
      }
    }
    &__titleBox {
      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 50%;
        right: 2px;
        background: url('~@/assets/icon/icon_arrow_right_gray.svg') no-repeat;
        background-size: 100% auto;
        width: .375rem;
        height: .6875rem;
        margin-top: -3px;
      }
    }
    &__mapIcon {
      width: 18px;
    }
    &__address {
      flex: 1;
    }
    &__mapBtn {
      border: 1px solid #CACCCF;
      border-radius: 15px;
      font-size: .75rem;
      line-height: 1.5;
      margin-left: auto;
      padding: 5px 12px;
    }
    &__tagList {
      .bene-icon {
        border-radius: .25rem;
      }
    }
    &__stockIcon {
      .plan-icon__vacancy {
        border-radius: .25rem;
      }
    }
    &__priceWrap {
      &--inside {
        display: block;
      }
    }
    &__priceTotalWrap {
      display: block;
    }
    &__bottomWrap {
      align-items: start;
    }
    &__granted {
      width: calc(100% - 5.625rem);
    }
    &__point {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: .75rem;

      &--point {
        font-weight: bold;
        color: #E60021;
        margin-right: 4px;
      }
      &--number {
        font-size: 1rem;
      }
      &--percent {
        font-size: .625rem;
        background: #fff;
        border-radius: 4px;
        padding: 2px 5px;
      }
      &--rakuten {
        width: 100%;
        margin: 0;
      }
    }
    &__planDetail {
      width: 5.625rem;
      &--icon {
        width: 6px;
      }
    }
  }
  .footer {
    .plan-detail-button {
      font-size: .875rem;
      line-height: 20px;
      width: 100%;
      height: 2.5rem;
    }
  }
}
</style>
